// © Microsoft Corporation. All rights reserved.

/**
 * Default name for the content action toolbar experience
 */
export const experienceDefaultName = "ContentActionsToolbar";

/**
 * Windows sizes to trigger breakpoint tracker
 */
export const BreakpointIndexToPx = [0, 1152, 1263];

/**
 * The breakpoint indexes to be maped by breakpoint tracker
 */
export enum ToolbarBreakpoints {
    Breakpoint3_1 = 0,
    Breakpoint3_2 = 1,
    Breakpoint3_3 = 2
}

/**
 * Constant names for telemetry data
 */
export enum TelemetryConstants {
    socialToolbarTelemetryName = "socialtoolbar",
    closeDialogTelemetryName = "Close",
    copyLinkTelemetryName = "CopyLink",
    shareArticleTelemetryName = "ShareArticle",
    shareDialogTelemetryName = "ShareDialog"
}

/**
 * Spa placeholders Ids
 */
export enum PlaceHolderId {
    vertical = "content-actions-toolbar-vert",
    horizontal = "content-actions-toolbar-horiz"
}

/**
 * Action keys for like/dislike
 */
export enum LikeDislikeActionKey {
    like = "like",
    dislike = "dislike",
    undoliked = "undoliked",
    undodisliked = "undodisliked"
}

/**
 * action keys available in content action
 */
export enum SelectPropKey {
    onLike = "onLike",
    onDislike = "onDislike",
    onOpenOptions = "onOpenOptions",
    onShareDialogOpen = "onShareDialogOpen"
}

/**
 * Content Status
 */
export enum Status {
    None = "none",
    Like = "like",
    DisLike = "dislike"
}